import { Col, Row } from "react-bootstrap";

export default function Limits({ item }) {

  // This component displays the limits of the agenda event in a colored row
  // Each limit is represented by a colored column with the respective text
  return (
    <>
      <Row className='limits'>
        <Col style={{ backgroundColor: "#146c43", color: "#ffffff", textAlign: "center" }}>{item?.agendaEvent.green}</Col>
        <Col style={{ backgroundColor: "#ffc107", color: "#000000", textAlign: "center" }}>{item?.agendaEvent.amber}</Col>
        <Col style={{ backgroundColor: "#dc3545", color: "#ffffff", textAlign: "center" }}>{item?.agendaEvent.red}</Col>
      </Row>
    </>
  );
}